__turbopack_context__.v({
  "className": "nanumsquareround_d6028940-module__H4ycma__className",
  "variable": "nanumsquareround_d6028940-module__H4ycma__variable",
});
